/**
 * Guarded PostHog capture (project100 T1003 wiring).
 *
 * `posthogCapture` is being added to `@/config/posthog` in parallel. This
 * wrapper dynamically imports the module and calls the export only if it
 * exists, so analytics can never break the page — at typecheck time or at
 * runtime — regardless of whether the export has landed yet.
 */

type CaptureFn = (event: string, properties?: Record<string, unknown>) => void;

export function posthogCapture(event: string, properties?: Record<string, unknown>): void {
  void import("@/config/posthog")
    .then((mod) => {
      const capture = (mod as { posthogCapture?: CaptureFn }).posthogCapture;
      capture?.(event, properties);
    })
    .catch(() => {
      // analytics must never break the page
    });
}
